import { Table } from "../../../features/Table";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

import { type S3Issuer, issuers_columns } from "./columns";
import { type FilterS3IssuersSchema, FilterS3Issuers } from "./filter";
import { useTranslation } from "react-i18next";

export const S3IssuersTable = () => {
  const { t } = useTranslation(["tables"]);
  return (
    <Table<S3Issuer, FilterS3IssuersSchema>
      label={t(`${Tables.S3_ISSUERS}.title`, { defaultValue: "Issuers" })}
      client={Clients.S3}
      table_name={Tables.S3_ISSUERS}
      columns={issuers_columns}
      filter={<FilterS3Issuers />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.S3}/${Tables.S3_ISSUERS}/new`,
        },
      ]}
    />
  );
};
